import './KeyValue.scss';

import classNames from 'classnames';
import { HelperPopper } from 'primary/helpers/HelperPopper';
import { useTranslate } from 'primary/hooks/useTranslate';
import React, { ReactElement, ReactNode } from 'react';

interface KeyValueProps {
  className?: string;
  keyValue: string;
  value?: string | ReactElement;
  accent?: boolean;
  valueAccent?: boolean;
  color?: 'green' | 'orange';
  tagged?: boolean;
  absolutePopper?: boolean;
  alignStart?: boolean;
  ellipsis?: boolean;
  wrap?: boolean;
  helper?: ReactNode;
  helperPopper?: ReactNode;
}

export const KeyValue = ({
  className,
  keyValue,
  value,
  accent,
  valueAccent,
  color = 'orange',
  tagged,
  helper,
  helperPopper,
  absolutePopper,
  alignStart,
  wrap,
  ellipsis,
}: KeyValueProps) => {
  const t = useTranslate();
  return (
    <div
      className={classNames('keyValue', className, {
        '-tagged': tagged,
        '-alignStart': alignStart,
        '-absolutePopper': absolutePopper,
        '-wrap': wrap,
      })}
    >
      <span
        className={classNames('keyValue__key', {
          '-accent': accent,
          '-green': color === 'green',
          '-orange': color === 'orange',
        })}
      >
        {keyValue}
      </span>
      <span
        className={classNames('keyValue__value', {
          '-valueAccent': valueAccent,
          '-green': color === 'green',
          '-orange': color === 'orange',
          '-ellipsis': ellipsis,
        })}
      >
        {value || t('general.keyValueNoValue')}
      </span>
      {!helperPopper && helper && <HelperPopper>{helper}</HelperPopper>}
      {helperPopper ? helperPopper : null}
    </div>
  );
};
